
export class LocalPack__Branch {
    constructor(dto) {
        this.id = dto.id
        this.name = dto.name
        this.address = 'Большая малая, 13'
    }
}

export class LocalPack__Keyword {
    constructor(dto) {
        this.id = dto.id
        this.name = dto.name
        this.position = 13
        this.frequency = 6666
        this.usedInBranches = dto.usedInBranches
        this.sources = [
            new LocalPack__Source({ name: 'Google Maps', change: -3 }),
            new LocalPack__Source({ name: 'Яндекс', change: 4 }),
            new LocalPack__Source({ name: '2GIS', change: 0 }),
        ]
        this.positionHistory
    }
}

export class LocalPack__Source {
    constructor(dto) {
        this.name = dto.name
        this.change = dto.change
    }
}


export function makeBaseComponent({mapGetters, mapActions,}) {
    return {
        computed: {
            ...mapGetters([
                'paginator',
            ]),
        },
        watch: {
            // isInitDataReady(value) {
            //     if (value) {
            //         setTimeout(() => {
            //             // this.setEventListeners()
            //         })
            //     }
            // },
        },
        methods: {
            ...mapActions([
                'changePage',
                'changePageSize',
            ]),
            setEventListeners() {
                // TODO Возникают проблемы с синхронизацией момента готовности данных и инициализацией компонента.
                // TODO Так же нужно вручную следить за подпиской и отпиской от событий.
                // this.$refs.paginator && this.$refs.paginator.$on('changePage', (value) => {
                //     this.changePage(value)
                // })
                // this.$refs.paginator && this.$refs.paginator.$on('changePageSize', (value) => {
                //     this.changePageSize(value)
                // })
            },
            removeEventListeners() {
                // this.$refs.paginator && this.$refs.paginator.$off()
            }
        },
        created() {
            // this.setEventListeners()
        },
        destroyed() {
            // this.removeEventListeners()
        }
    }
}